import axios, { AxiosResponse } from 'axios';
import { DeleteCietyResType, GetOrCreateCietyResType } from '../type';

export const connectCiety = async (projectId: string, subdomain: string) => {
  const { data } = await axios.post<string, AxiosResponse<GetOrCreateCietyResType>>('/@api/ciety/connect', {
    projectId,
    subdomain,
  });

  return data;
};

export const disconnectCiety = async (projectId: string, daoId: string) => {
  const { data } = await axios.post<string, AxiosResponse<DeleteCietyResType>>('/@api/ciety/disconnect', {
    projectId,
    daoId,
  });

  return data;
};
